export default (values, value, type) => value >= type;
